import BaseComponent from '/webresources-sources/js/components/base-component';
import { urlQuery } from '/webresources-sources/js/util/url';
import { defineComponent, upgradeComponents } from '/webresources-sources/js/util/jquery';
import { asyncHTMLInjected } from '/webresources-sources/js/util/html';

export default class PagesSearchListComponent extends BaseComponent {
    properties() {
        return {
            searchPath: '',
            contentPath: '',
            searchString: '',
            pageSize: 7,
            currentPage: 0,
            pageIds: [],

            buttonTextNext: '',
            buttonTextRemaining: '',

            previousPageIndex: -1,
            mockPages: '',
        };
    }

    connected() {
        this.previousPageIndex = this.currentPage - 1;

        if (this.searchString) {
            this.searchPages();
        }

        this._searchInput = this.element.querySelector('input');
        this._searchInput.focus();
        this.updateNextButtonText();
    }

    afterUpdate() {
        const resultsContainer = this.element.querySelector('.results-container');
        resultsContainer.classList.toggle('d-none', !this.searchString);

        /** @type PageCount */
        const pageCount = this.element.querySelector('page-count');
        pageCount.totalItems = this.pageIds.length;
        pageCount.currentPage = this.currentPage;
        pageCount.previousPageIndex = this.previousPageIndex;

        const previousPageContainer = this.element.querySelector('.previous-page');
        const noContentContainer = this.element.querySelector('.no-content');
        const nextPageContainer = this.element.querySelector('.next-page');

        previousPageContainer.classList.toggle('d-none', !this.hasPreviousPage);
        if (this.pageIds.length === 0) {
            noContentContainer.classList.remove('d-none');
        } else {
            noContentContainer.classList.add('d-none');
        }
        nextPageContainer.classList.toggle('d-none', !this.hasNextPage);

        this.updateUrl();
        this.updateNextButtonText();
    }

    watch() {
        return {
            searchString: () => {
                this.searchPages();
            },
            pageIds: (pageIds) => {
                if (pageIds.length === 0) return;

                this.dispatch('loading-start');
                this.fetchPages().then((html) => {
                    this.dispatch('loading-end');
                    const container = this.element.querySelector('.pages');
                    $(container).html($(html).find('.pages').html());

                    asyncHTMLInjected();
                    upgradeComponents(container);
                });
            },
        };
    }

    events() {
        return {
            form: {
                submit: (e) => {
                    // TODO: cant prevent... because raysono-magnolia-form registers a listener on the submit event and will trigger the submit() again... :(
                    /*e.preventDefault();
                    const input = this.element.querySelector('[name="search"]');
                    this.searchString = input.value;
                    this.updateUrl();*/
                },
            },
            '[data-suggestion]': {
                click: (e) => {
                    // A search suggestion was clicked.
                    // 1. its value (data-suggestion) is copied into the search field and
                    // 2. the search is triggered by submitting the form.
                    this._searchInput.value = e.target.closest('[data-suggestion]').getAttribute('data-suggestion');
                    this._searchInput.form?.submit();
                },
            },
            '[load-previous-page]': {
                click: (e) => {
                    e.preventDefault();
                    this.prependPages();
                },
            },
            '[load-next-page]': {
                click: (e) => {
                    e.preventDefault();
                    this.appendPages();
                },
            },
            '[data-page]': {
                click: (e) => {
                    const pageContainer = e.target.closest('[data-page]');
                    if (e.target.nodeName === 'A' && pageContainer) {
                        this.currentPage = parseInt(pageContainer.dataset.page);
                    }
                },
            },
        };
    }

    getPages(currentPage) {
        const startItem = currentPage * this.pageSize;
        const endItem = startItem + this.pageSize;

        return this.pageIds.slice(startItem, endItem);
    }

    get hasPreviousPage() {
        return this.previousPageIndex >= 0;
    }

    get hasNextPage() {
        const totalItems = this.pageIds.length;
        const totalPages = totalItems / this.pageSize;

        return this.currentPage < totalPages - 1;
    }

    searchPages() {
        if (this.element.hasAttribute('mock-pages')) {
            this.pageIds = this.mockPages ? this.mockPages.split(',').sort(() => (Math.random() > 0.5 ? 1 : -1)) : [];
            setTimeout(() => {
                this.dispatch('loading-end');
                this.requestUpdate();
            }, 0);
            return;
        }

        this.dispatch('loading-start');

        // always use lowercase for searching, as no results are returned when search text contains uppercase characters
        const query = this.searchString.toString().toLowerCase();

        fetch(`${this.searchPath}&q=${query}`)
            .then((response) => {
                return response.json();
            })
            .then((json) => {
                if (json.entries) {
                    const pages = json.entries;
                    const normalPages = [];
                    const dsftPages = [];
                    for (const page of pages) {
                        if (page.type && page.type === 'bayern-tourism-frontend:pages/dsft-detail-page') {
                            dsftPages.push(page);
                        } else {
                            normalPages.push(page);
                        }
                    }

                    this.pageIds = [...normalPages.map((entry) => entry.uuid), ...dsftPages.map((entry) => entry.uuid)];
                }
            })
            .catch((error) => {
                console.log({ error });
            })
            .finally(() => {
                this.dispatch('loading-end');
                // This is the same delay as for the loading-container delay
                setTimeout(() => {
                    this.requestUpdate();
                }, 250);
            });
    }

    prependPages() {
        this.fetchPages(this.previousPageIndex).then((html) => {
            const container = this.element.querySelector('.pages');
            $(container).prepend($(html).find('.pages').html());

            asyncHTMLInjected();
            upgradeComponents(container);

            this.previousPageIndex--;

            const previousPageContainer = this.element.querySelector('.previous-page');
            previousPageContainer.classList.toggle('d-none', !this.hasPreviousPage);
        });
    }

    appendPages() {
        this.fetchPages(this.currentPage + 1).then((html) => {
            const container = this.element.querySelector('.pages');
            $(container).append($(html).find('.pages').html());

            asyncHTMLInjected();
            upgradeComponents(container);

            this.currentPage++;

            this.updateUrl();

            const nextPageContainer = this.element.querySelector('.next-page');
            nextPageContainer.classList.toggle('d-none', !this.hasNextPage);
        });
    }

    fetchPages(currentPage = this.currentPage) {
        const urlParameters = { pages: this.getPages(currentPage), currentPage };
        return fetch(`${this.contentPath}?${urlQuery(urlParameters)}`).then((result) => result.text());
    }

    updateUrl() {
        const urlParameters = {
            search: this.searchString,
            currentPage: this.currentPage > 0 ? this.currentPage : undefined,
        };
        history.replaceState(urlParameters, '', `?${urlQuery(urlParameters, true)}`);
    }

    updateNextButtonText() {
        const { pageSize, currentPage, pageIds, buttonTextNext, buttonTextRemaining } = this;
        // Pages starts with 0 so we need to subtract totalPages by 1
        const totalPages = Math.ceil(pageIds.length / pageSize) - 1;
        const nextPageIsLast = totalPages <= currentPage + 1;

        const button = this.element.querySelector('.next-page .btn');
        button.textContent = nextPageIsLast ? buttonTextRemaining : buttonTextNext;
    }
}

defineComponent('pages-search-list-component', PagesSearchListComponent);
